var news = function name() {

  // NodeList foreach
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
  }

  var news = document.querySelectorAll('.news__item')
  var more = document.querySelector('.js--news-more')

  more && more.addEventListener('click', moreNews)

  news.forEach(function(el) {
    var link = el.querySelector('.news__read')
    var textEl = el.querySelector('.news__text')
    var textLenght = textEl.innerText.split(/\r\n|\r|\n/).length

    if(textLenght < 3 ) el.classList.add('is-active');

    link.addEventListener('click', function() {
        news.forEach(function(e) {
            e.classList.add('is-active')
        })
    })
  })

  function moreNews(e) {
    e.preventDefault();
    document.querySelector('.news__subnews').classList.add('news__subnews--show')
    more.style.display = 'none'
  }
}


export default news();
